import Ext from 'Ext'
import WeekPicker from './at_date_picker'
Ext.namespace('AT.menu');


// TODO delete?
const WeekPickerItem = Ext.extend(Ext.menu.DateItem,{
    constructor : function(config)
    {
        WeekPickerItem.superclass.constructor.call(this, new WeekPicker(config), config);

        this.picker = this.component;
        this.addEvents('select');

        this.picker.on("render", function(picker)
        {
            picker.getEl().swallowEvent("click");
            picker.container.addClass("x-menu-date-item");
        });

        this.picker.on("select", this.onSelect, this);
    }
});

Ext.extend(WeekPickerItem, Ext.menu.Adapter,
{
    // private
    onSelect : function(picker, date)
    {
        this.fireEvent("select", this, date, picker);
        WeekPickerItem.superclass.handleClick.call(this);
    }
});

export default WeekPickerItem



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_week_picker_item.js